<template>
  <div>
    <table
      cellpadding="10"
      cellspacing="0"
      width="95%"
      class="hover-table invoices-table"
      align="center"
    >
      <thead>
        <tr>
          <td valign="middle">
            <!-- <strong>{{ $t("beneficiariesTableCNP") }}</strong> -->
          </td>
          <td valign="middle">
            <strong>{{ $t("title.firstNameLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("title.lastNameLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("title.beneficiariesTableCNP") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("title.beneficiariesTableEmail") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("title.beneficiariesTableMobile") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("title.beneficiariesTableStatus") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("title.companyNameLabel") }}</strong>
          </td>
          <td cvalign="middle">
            <!-- <strong>{{ $t("valueLabel") }}</strong> -->
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-if="this.beneficiaries === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr>
        <template v-for="(beneficiary, index) in beneficiaries" :key="index">
          <tr
            class="trhover parent"
            :class="index % 2 === 0 && 'gri-cell'"
          >
            <td valign="middle">
              <a
                class="detailsOrderMobile priority-show-6 display-inline-block"
                @click="setBeneficiary(beneficiary)"
              >
                <font-awesome-icon
                  icon="minus-circle"
                  v-if="
                    detailsMobile && beneficiary === beneficiarySelectedMobile
                  "
                />
                <font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
              </a>
              <!-- {{ beneficiary.cnp }} -->
            </td>
            <td valign="middle">
              {{ beneficiary.first_name }}
            </td>
            <td valign="middle">
              {{ beneficiary.last_name }}
            </td>
            <td valign="middle" class="priority-1">
              {{ beneficiary.cnp }}
            </td>
            <td valign="middle" class="priority-2">
              {{ beneficiary.email }}
            </td>
            <td valign="middle" class="priority-2">
              {{ beneficiary.mobile_phone }}
            </td>
            <td valign="middle" class="priority-3">
              {{ beneficiary.active ? $t('title.cardStatus_A') : $t('title.cardStatus_D') }}
            </td>
            <td valign="middle" class="priority-4">
              {{ beneficiary.customer_name }}
            </td>
            <td valign="middle">
                  <a
                    class="see-more cursor-pointer"
                    @click="setBeneficiary(beneficiary)"
                  >
                    <font-awesome-icon
                      icon="arrow-alt-circle-right"
                      size="2x"
                    />
                  </a>
                </td>
          </tr>
          <tr
            class="child"
            :class="index % 2 === 0 && 'gri-cell'"
            v-show="detailsMobile && beneficiary === beneficiarySelectedMobile"
          >
            <td colspan="12">
              <p class="priority-show-1">
                <strong>{{ $t("title.beneficiariesTableCNP") }} : &nbsp;&nbsp;</strong>
                <span>{{ beneficiary.cnp }}</span>
              </p>
              <p class="priority-show-2">
                <strong>{{ $t("title.beneficiariesTableEmail") }} : &nbsp;&nbsp;</strong>
                <span>{{ beneficiary.email }}</span>
              </p>
              <p class="priority-show-2">
                <strong>{{ $t("title.beneficiariesTableMobilePhone") }} : &nbsp;&nbsp;</strong>
                <span>{{ beneficiary.mobile_phone }}</span>
              </p>
              <p class="priority-show-3">
                <strong>{{ $t("title.beneficiariesTableStatus") }} : &nbsp;&nbsp;</strong>
                <span>{{ beneficiary.active ? $t('title.cardStatus_A') : $t('title.cardStatus_D') }}</span>
              </p>
              <p class="priority-show-4">
                <strong>{{ $t("title.beneficiariesTableCustomerName") }} : &nbsp;&nbsp;</strong>
                <span>{{ beneficiary.customer_name }}</span>
              </p>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
  import moment from "moment";
  import Cookies from "js-cookie";

  export default {
    name: "CardTransactionTable",
    props: {
      beneficiaries: Array,
      msg: String,
    },
    data() {
      return {
        detailsMobile: false,
        beneficiarySelectedMobile: null,
        transactionError: null,
      };
    },
    methods: {
      displayDate(date) {
        return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format(
          "DD/MM/YYYY HH:mm"
        );
      },
      selectTransactionMobile(index) {
        this.beneficiarySelectedMobile = this.beneficiaries[index];
        this.detailsMobile = !this.detailsMobile;
      },
      showModalPopup(elementId, show) {
        if (show) {
          document.getElementById(elementId).style.visibility = "visible";
        } else {
          document.getElementById(elementId).style.visibility = "hidden";
        }
      },
      setBeneficiary(beneficiary) {
        Cookies.set(
          "selectedBeneficiary",
          beneficiary.up_uuid,
          {
            sameSite: "Strict"
          }
        );
        localStorage.setItem("selected_beneficiary", JSON.stringify(beneficiary));
        this.$router.push({
          name: "support_beneficiary",
          query: {
            first_view: "true",
          },
        });
      },
    },
    mounted(){
      localStorage.removeItem("selected_beneficiary");
    }
  };
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
